import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import YesNoModal from '../YesNoModal';

function UserCard(props) {
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    const deleteUser = () => {
        console.log("Removing user: " + JSON.stringify(props.user));
        props.delete(props.user.userID);
    };

    const userJSX = (
        <div className="role-user card item-details">
            <div className="properties">
                <div className="svg-label">
                    <i className="fas fa-envelope"></i>
                    <span>{props.user.emailAddress}</span>
                </div>
            </div>
            {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                <div className="actions-horizontal">
                    <div onClick={toggleDeletionConfirmationModal} className="action-icon action-delete">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <YesNoModal title="Confirm Deletion" yesClick={deleteUser} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want remove this User?</YesNoModal>
                </div>
            ) : null}
        </div>
    );

    return userJSX;
}

export default UserCard;